import React, { useMemo } from 'react'

const BASE_POINTS = [
    [30, 30],
    [105, 45],
    [215, 15],
    [305, 30],
    [355, 45],
    [375, 115],
    [350, 150],
    [315, 175],
    [275, 150],
    [150, 175],
    [50, 150],
    [15, 75]
]

const makePoints = () => {
    let allPoints = []
    BASE_POINTS.forEach((point, index) => {
        // generate a random number between -10 and 10
        let randomX = Math.random() * 40 - 20
        let randomY = Math.random() * 40 - 20
        allPoints.push(`${point[0] + randomX} ${point[1] + randomY}`)
    })
    return allPoints.join(' ')
}

const LocationSvg = ({ location }) => {
    const svgPoints = useMemo(() => {
        return makePoints()
    }, [])

    const renderSvg = () => {
        if (location?.svgShape) {
            return <img src={location.svgShape?.url} alt={location.svgShape?.alt} />
        }
        return (
            <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" viewBox="0 0 400 200">
                <polygon points={svgPoints} />
            </svg>
        )
    }

    return (
        <div className={`bg-svg ${location?.color}`}>
            { renderSvg() }
        </div>
    )
}

export default LocationSvg
